module.exports = __webpack_public_path__ + "static/img/blockPuzzle.7f863e06.png";